import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BenefitBlockData from '../../../Models/Content/BenefitBlockData';
import Benefit from './Benefit';

export default class BenefitBlock extends EpiComponent<BenefitBlockData> {

    public render(): ReactNode | ReactNodeArray | null {
        return (
            <>
                <div className={'benefit-block'}>
                    <Benefit iContent={this.props.data} context={this.getContext()} />
                </div>
            </>
        );
    }
}
